// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__list-description[data-v-0307e06c]{background-color:#eceef7;border-radius:10.4px;padding:12px 20px}.component__receipt-form textarea[data-v-0307e06c]{font-size:15.2px}", ""]);
// Exports
module.exports = exports;
